export default __webpack_public_path__ + "static/media/bars.6aa31c80.svg";